import {decorate, observable} from 'mobx';
import {faWindow} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';
import {WidgetLayout} from './widgetLayout';

export class TerminalLayout extends BaseModel {
  static faIcon = faWindow;

  saveableProperties = ['id', 'isDefault', 'name', 'widgetLayouts', 'scale'];

  static prepareApiPayload(model) {
    return {
      ...model,
      widgetLayouts: JSON.stringify(model.widgetLayouts.map((l) => WidgetLayout.getPlainSaveableObject(l)) || []),
    };
  }
}

decorate(TerminalLayout, {
  id: observable,
  name: observable,
  isDefault: observable,
  widgetLayouts: observable,
  scale: observable,
});
